// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function IconPIPExpand(Props) {
  var className = Props.className;
  var tmp = {
    height: "20",
    width: "22",
    fill: "none",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("svg", tmp, React.createElement("path", {
    d: "M9.125 9.4375C10.2296 9.4375 11.125 8.5421 11.125 7.4375V2.4375C11.125 1.33293 10.2296 0.4375 9.125 0.4375H2.125C1.02043 0.4375 0.125 1.33293 0.125 2.4375V7.4375C0.125 8.19689 0.54823 8.8574 1.17168 9.1961C1.45507 9.3501 1.77982 9.4375 2.125 9.4375H9.125ZM9.125 10.4375H2.125C1.77436 10.4375 1.43778 10.3773 1.125 10.2668V16.1875C1.125 17.9824 1.125 19.4375 1.125 19.4375H17.875C19.6699 19.4375 21.125 19.4375 21.125 19.4375V3.4375C21.125 3.4375 19.6699 3.4375 17.875 3.4375H12.125V7.4375C12.125 9.0944 10.7819 10.4375 9.125 10.4375ZM13.375 14.4375H15.0643L12.3447 11.7178C12.0518 11.4249 12.0518 10.9501 12.3447 10.6572C12.6376 10.3643 13.1124 10.3643 13.4053 10.6572L16.125 13.3768V11.6875C16.125 11.2733 16.4608 10.9375 16.875 10.9375C17.2892 10.9375 17.625 11.2733 17.625 11.6875V15.1875C17.625 15.6017 17.2892 15.9375 16.875 15.9375H13.375C12.9608 15.9375 12.625 15.6017 12.625 15.1875C12.625 14.7733 12.9608 14.4375 13.375 14.4375Z",
    fill: "currentColor"
  }));
}
IconPIPExpand.displayName = "IconPIPExpand";
var make = IconPIPExpand;
export { make };
/* react Not a pure module */